<template>
    <div style="margin: 10px;">
        <div></div>
        <div id="scroll-thumb" class="thumb-container" style="width: 100%; text-align: right; overflow-y: auto;" :style="{'max-height': mh ? mh + 'px' : 'unset'}">
            
            <div v-for="preview in brothers" class="thumbnail" :class="{'active': preview.sid == activeOne.sid}"
                v-if="ready && brothers && brothers.length > 0" >
                <a href="#" @click.prevent="navigateToBrother(preview)">
                    <div class="caption">
                        <p>{{preview.des}}</p>
                    </div>
                    <div class="embed-responsive embed-responsive-4by3 bg-cover" style="width: 100%;" 
                    :style="{'background-image': 'url('+ $root.getGraphic(preview.gra[0].sfn, 'thumb', true) + ')'}"></div>
                </a>
            </div>
            <div v-if="ready && brothers.length == 0" style="text-align: center; padding-top: 10px;">
                <span>{{$Jed.firstUpperTranslate('no preview available', null)}}</span>
            </div>
            
        </div>
    </div>
</template>

<script>

import { eventBus } from "../../eventbus";

    export default {
        props: {
            activeData: {
                type: Object,
                default: null
            },
            mh: Number
        },
        mounted: function(){

            if(this.activeData != null){
                this.$nextTick(function(){
                     this.loadPreviews();
                })
            }
            try {  
                var def = this.$root.supportDefaults.Anteprime;
                this.$root.sup_apply(null, null, null, def);
            } catch(err){}
            
        },
        created: function(){
            this.$nextTick(function(){
                var vm = this;
                eventBus.$on("newSupportSide", function(size){
                    vm.$root.supportDefaults.Anteprime = size;
                })
            })
        },
        beforeDestroy: function(){
            eventBus.$off("newSupportSide")
        },
        data: function(){
            return {
                activeOne: null,
                listingChildrenOf: null,
                brothers: null,
                ready: false,
                ext: null
            }
        },
        watch: {
            activeData: function(){
                if(this.activeData != null){
                    this.loadPreviews();
                }
            }
        },
        methods: {
            loadPreviews: function(){
                this.activeOne = this.activeData.father;
                var isThereActiveImg = false;
                try {
                    isThereActiveImg = this.activeOne.gra[0].sfn != null; 
                    if(!isThereActiveImg){
                        this.activeOne.gra[0].sfn = "missing";
                    }
                } catch(err){}
               
                
                this.ready = false;
                if(this.activeOne.fid != this.listingChildrenOf){
                    //se ho navigato all'interno dello stesso ramo, non sto a ricaricare le informazioni
                    this.listingChildrenOf = this.activeOne.fid;
                    this.$root
                    .microservice({
                        role: "catalog",
                        cmd: "SearchByFather",
                        params: {
                            fid: this.activeOne.fid,
                            labels: ["des"],
                            prod_info: ["gra"],
                            leaves: true,
                            meta: false
                        }
                    })
                    .then(response => 
                        {
                            var res = response.body;
                            try {
                            res = JSON.parse(response.body);
                            } catch (err) {}

                            this.brothers = null;
                            this.brothers = [];
                            if (res.children) {
                                for (var i = 0; i < res.children.length; i++) {
                                    var obj = res.children[i];
                                    
                                    var isThereBrotherImg = false;
                                    try {
                                        isThereBrotherImg = obj.gra[0].sfn != null;
                                    } catch(err){}
                                    if(!isThereBrotherImg){
                                        if(obj.gra == null){
                                            obj.gra = [{}]
                                        }
                                        obj.gra[0].sfn =  "missing";
                                    }
                                    this.brothers.push(obj);
                                }

                                // se sto caricando le anteprime dei fratelli della radice (fid = index as root) E l'albero caricato è di un sotto-modello (model of cat)
                                if(this.activeOne.fid == this.$root.index_as_root && this.$root.model_of_cat != null){
                                    // non voglio vedere le anteprime dei fratelli, ma solo quella della radice (il problema non si pone con l'intero catalogo, in quanto c'è sempre un solo nodo con fid: "Modelli")
                                    this.brothers = this.brothers.filter(function(obj){
                                        return obj.sid == this.$root.model_of_cat;
                                    }, this);
                                }

                             
                                this.ready = true;
                            }

                            this.$nextTick(function(){
                                try{
                                    var nt = Math.max(document.getElementsByClassName("thumbnail active")[0].offsetTop - 140, 0);
                                    document.getElementById("scroll-thumb").scrollTop = nt;
                                } catch(err){
                                    console.log(err)
                                }
                            })
                        },
                        err => {
                            this.ready = true;
                            //vedi gestione errore in main.js > microservice
                        })
                        .catch(err => {
                            console.log(err);
                            var msg = err && err.body && err.body.error ? err.body.error : ''
                            eventBus.$emit('alert', {
                                message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
                                type: "error",
                                action: ''
                            })
                        })
                } else {
                    this.ready = true;
                }
            },
            navigateToBrother: function(preview){
                this.$root.navigateTo(preview.sid, preview.fid)
            }
        }
    }
</script>

<style scoped>
.thumbnail {
    width: 100%;
    max-width: 250px;
    background: transparent;
    display: inline-block;
    margin-bottom: 0px;
}

.thumbnail .caption {
    padding: 2px 5px 5px 5px;
    color: #b8c7ce;
}

.thumbnail .caption > p {
    text-align: right;
    margin: 0px;
}

.thumbnail.active {
    background: #017ebc;
}

.thumbnail.active .caption{
    color: white;
}

.embed-responsive.bg-cover {
    background-position: left 100% 100%;
    -webkit-background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    -o-background-size: 100% 100%;
    background-size: 100% 100%;
    
    background-position: center;
    background-size: cover;
}

</style>


// WEBPACK FOOTER //
// src/components/menu-sup-components/Anteprime.vue?855a0d5e